import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const START_LEFT = 9;
const MIN_LEFT = 3;
export function ScarcityBar() {
  const [left, setLeft] = useState(START_LEFT);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(prev => prev > MIN_LEFT ? prev - 1 : prev);
    }, 28000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - left) / TOTAL_SPOTS * 100;
  return <div className="w-full rounded-2xl bg-white p-4 sm:p-5 text-left shadow-sm ring-1 ring-alert/20" data-id="element-57" data-mp="2g6mh2dwc7o0w">
      <div className="flex items-center justify-between gap-3" data-id="element-58" data-mp="227dbs99o6ebp">
        <p className="flex items-center gap-2 text-[15px] sm:text-base font-bold text-ink" data-id="element-59" data-mp="274n1zr4vuu0l">
          <FlameIcon className="h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-60" data-mp="eyqd07x2rqj" />
          Only <span className="text-alert" data-id="element-61" data-mp="5drzyhk31ylf">{left} spots</span> left at the launch price
        </p>
        <span className="text-sm font-extrabold text-alert tabular-nums" data-id="element-62" data-mp="33mv7qm2i5f6s">{Math.round(filled)}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-alert/10" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-63" data-mp="2zljdg38oo5s9">
        <motion.div className="h-full rounded-full bg-alert" initial={false} animate={{
        width: `${filled}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-64" data-mp="38foch9xz0niv" />
      </div>
      <p className="mt-2 text-xs sm:text-sm text-ink/60" data-id="element-65" data-mp="2ulx2y1k8p3n5">
        When the spots run out, the price returns to the full reference value.
      </p>
    </div>;
}